import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function CloseX({ color = 'icon.primary', strokeWidth = '1.5', ...props }) {
  return (
    <IconBase viewBox='0 0 15 14' {...props}>
      <Path
        d='M13 2.07336L2 12.1535'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M13 12.1535L2 2.07336'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

CloseX.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
}

export default CloseX
